const initialState = {
  features: {},
  askTheExpert: {
    expert: null,
  },
  i18n: {},
};

export default (state = initialState, action) => state;
